import styled from 'styled-components'

import type { ButtonTheme } from '@/@bothrs-theme/types/button-theme'
import type { IconButtonProps } from './IconButton.types'

const StButton = styled.button<Pick<IconButtonProps, 'variant' | 'size'>>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  appearance: button;
  outline: none;
  user-select: none;
  cursor: pointer;

  ${({ theme, variant, size }) => {
    const buttonTheme = theme.Components.Button[variant] as ButtonTheme

    return `
      width: ${size === 'small' ? 32 : 48}px;
      height: ${size === 'small' ? 32 : 48}px;
      color: ${buttonTheme.Text};
      background-color: ${buttonTheme.Fill};
      border: 1px solid ${buttonTheme.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      transition: all 250ms ease-out;


      &:hover {
        background-color: ${buttonTheme.ActiveFill};
      }

      &:active {
        color: ${buttonTheme.ActiveText};
        background-color: ${buttonTheme.ActiveFill};
        border: 1px solid ${buttonTheme.ActiveBorder};
      }

      &:disabled {
        color: ${buttonTheme.DisabledText};
        background-color: ${buttonTheme.DisabledFill};
        border: 1px solid ${buttonTheme.DisabledBorder};
      }
    `
  }}
`

export { StButton }
